export default __webpack_public_path__ + "static/media/33-AfterTheStorm.a0a33f74.jpeg";